import { CourseId } from '@business/entities/course';
import { Endpoint } from '../endpoint';
import { LineUpResponse, LineUpId, CompactLineUpResponse } from '@business/entities/lineUp';
import { UserId } from '@business/entities/account';
import { UserCourseResponse } from '@business/entities/user_course';

export function fetchLineups() {
  return Endpoint.get<CompactLineUpResponse[]>(`@gc/line-up`);
}

export function fetchLineup(id: LineUpId) {
  return Endpoint.get<LineUpResponse>(`@gc/line-up/line-up/${id}`);
}

export function createLineup(data: Partial<CompactLineUpResponse>) {
  return Endpoint.post<CompactLineUpResponse>(`@gc/line-up`, { data });
}

export function updateLineup(id: LineUpId, data: Partial<CompactLineUpResponse>) {
  return Endpoint.patch<CompactLineUpResponse>(`@gc/line-up/${id}`, { data });
}

export function deleteLineup(TaskId: LineUpId) {
  return Endpoint.delete<void>(`@gc/line-up/${TaskId}`);
}

export function addCourse(lineUpId: LineUpId, courseIds: CourseId[]) {
  return Endpoint.post<LineUpResponse>(`@gc/line-up/add-course/${lineUpId}`, { data: { courseIds } });
}

/* User Lineup */
export function enroll(id: CourseId, uids: UserId[]) {
  return Endpoint.post<LineUpResponse>(`@gc/line-up/enroll/${id}`, { data: { uids } });
}

export function unenroll(id: CourseId, uid: UserId, deleteType: boolean) {
  return Endpoint.post<LineUpResponse>(`@gc/line-up/unenroll/${id}`, { data: { uid, deleteType } });
}

export function restart(id: CourseId, uid: UserId) {
  return Endpoint.post<LineUpResponse>(`@gc/line-up/restart/${id}`, { data: { uid } });
}

export function getLineUpCourse(lineUpId: LineUpId, userId: UserId, courseId: CourseId) {
  return Endpoint.get<UserCourseResponse>(`@gc/line-up/course`, { params: { courseId, userId, lineUpId } });
}

export function sortCourses(id: LineUpId, ids: CourseId[]) {
  return Endpoint.post<void>(`@gc/line-up/sort-course/${id}`, { data: { ids } });
}

export function removeCourse(lineUpId: LineUpId, courseId: CourseId) {
  return Endpoint.delete<LineUpResponse>(`@gc/line-up/course/${lineUpId}`, { data: { courseId } });
}
